import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LensIcon from "@mui/icons-material/Lens";
import { Box, Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { ReactElement } from "react";

import { PromptTemplate } from "../../../types/prompt-template";
import { SCOPE_DISPLAY_NAMES } from "../constants";
import { formatDate } from "../utils";

const styles = {
  scopeChips: {
    display: "flex",
    gap: 0.5,
    flexWrap: "wrap",
  },
} as const;

interface LensTableRowProps {
  template: PromptTemplate;
  onEdit: (template: PromptTemplate) => void;
  onToggleStatus: (template: PromptTemplate) => void;
  onDelete: (template: PromptTemplate) => void;
}

const CATEGORY_COLOR_MAP: Record<string, "primary" | "secondary" | "default"> = {
  training: "primary",
  performance: "secondary"
};

const CategoryChip = ({ category }: { category: string }): ReactElement => (
  <Chip size="small" label={category} color={CATEGORY_COLOR_MAP[category] ?? "default"} />
);

const LensTableRow = ({ template, onEdit, onToggleStatus, onDelete }: LensTableRowProps): ReactElement => (
  <TableRow>
    <TableCell>
      <Tooltip title={template.enabled ? "Enabled" : "Disabled"}>
        <IconButton
          size="small"
          onClick={(): void => onToggleStatus(template)}
          color={template.enabled ? "success" : "default"}
        >
          <LensIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </TableCell>
    <TableCell>{template.title}</TableCell>
    <TableCell>{template.description}</TableCell>
    <TableCell><CategoryChip category={template.metadata.category} /></TableCell>
    <TableCell>{template.metadata.audience}</TableCell>
    <TableCell>{template.metadata.primary_function}</TableCell>
    <TableCell>
      <Box sx={styles.scopeChips}>
        {(template.metadata.scope || []).map((scope) => (
          <Chip key={scope} size="small" label={SCOPE_DISPLAY_NAMES[scope]} variant="outlined" />
        ))}
      </Box>
    </TableCell>
    <TableCell>{formatDate(template.modified)}</TableCell>
    <TableCell align="right">
      <Tooltip title="Edit">
        <IconButton onClick={(): void => onEdit(template)} sx={{ p: 0 }}><EditIcon /></IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton onClick={(): void => onDelete(template)} sx={{ p: 1 }} color="error"><DeleteIcon /></IconButton>
      </Tooltip>
    </TableCell>
  </TableRow>
);

export default LensTableRow;
